import { create } from 'zustand';

export const useTimerStore = create((set, get) => ({
  isRunning: false,
  isPaused: false,
  startTime: null,
  pausedAt: null,
  totalPausedMs: 0,
  topic: '',
  elapsedSeconds: 0,
  _interval: null,

  setTopic: (topic) => set({ topic }),

  start: () => {
    const { _interval, totalPausedMs, pausedAt } = get();
    if (_interval) clearInterval(_interval);

    const now = Date.now();
    const adjustedStart = pausedAt
      ? now - (pausedAt - get().startTime) - totalPausedMs
      : now;

    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - adjustedStart) / 1000);
      set({ elapsedSeconds: elapsed });
    }, 1000);

    set({
      isRunning: true,
      isPaused: false,
      startTime: adjustedStart,
      pausedAt: null,
      _interval: interval,
    });
  },

  pause: () => {
    const { _interval } = get();
    if (_interval) clearInterval(_interval);
    set({
      isRunning: false,
      isPaused: true,
      pausedAt: Date.now(),
      _interval: null,
    });
  },

  stop: () => {
    const { _interval, elapsedSeconds, topic } = get();
    if (_interval) clearInterval(_interval);
    const sessionData = {
      duration: elapsedSeconds,
      topic,
      endTime: new Date().toISOString(),
    };
    set({
      isRunning: false,
      isPaused: false,
      startTime: null,
      pausedAt: null,
      totalPausedMs: 0,
      topic: '',
      elapsedSeconds: 0,
      _interval: null,
    });
    return sessionData;
  },

  reset: () => {
    const { _interval } = get();
    if (_interval) clearInterval(_interval);
    set({
      isRunning: false,
      isPaused: false,
      startTime: null,
      pausedAt: null,
      totalPausedMs: 0,
      topic: '',
      elapsedSeconds: 0,
      _interval: null,
    });
  },
}));
